import React, { memo, useCallback } from 'react';
import { SettingsItemCard } from 'design-system';
import { IconFlame } from 'design-system/icons/IconFlame';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectUserDayStreak } from '../selectors';
import { formatCount } from '../utils';
const strings = {
    title: 'Streaks',
    // Singular for any count: "2,000 day streak with Emma"
    dayStreak: 'day streak with Emma',
    introduction: 'Track your daily streak with Emma',
};
const StreaksSettingsCard = () => {
    const navigation = useMainStackNavigation();
    const dayStreak = useAppSelector(selectUserDayStreak);
    // A new user's streak is just today, so the tile introduces the feature
    const isActive = dayStreak > 1;
    const onPress = useCallback(() => {
        navigation.navigateDeprecated('Streaks');
    }, []);
    return (<SettingsItemCard icon={<IconFlame height={24} width={24}/>} title={isActive ? formatCount(dayStreak) : strings.title} description={isActive ? strings.dayStreak : strings.introduction} onPress={onPress} testID="settings-streaks-card"/>);
};
export default memo(StreaksSettingsCard);
